export default __webpack_public_path__ + "static/media/user-management-gold.03204685.svg";